import { useEffect } from "react";

interface SEOMetaProps {
  jsonLd: Record<string, unknown> | Record<string, unknown>[];
  id?: string;
}

export default function SEOMeta({ jsonLd, id = "schema-jsonld" }: SEOMetaProps) {
  useEffect(() => {
    const scriptId = id;
    const existing = document.getElementById(scriptId);
    if (existing) {
      existing.remove();
    }

    const script = document.createElement("script");
    script.id = scriptId;
    script.type = "application/ld+json";

    if (Array.isArray(jsonLd)) {
      script.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@graph": jsonLd,
      });
    } else {
      script.textContent = JSON.stringify(jsonLd);
    }

    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) {
        el.remove();
      }
    };
  }, [jsonLd, id]);

  return null;
}